import { Component, ComponentRef, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { SharedModule } from "../../../modules/shared/shared.module";
import { SvgIconComponent } from "../../svg-icon/svg-icon.component";
import { TosTableComponent } from "../../tos-table/tos-table.component";
import { TableMenuOption, TableMeta } from "../../../models/table-meta.interface";
import CustomerAgreementListingTableConfig from "./config/CustomerAgreementLisitngTable.config.json";
import { SearchBarConfig, TableListRequest } from "../../../models/table-list-request.interface";
import { PaginatedListDataResponse } from "../../../models/paginated-list-data-response";
import { LoadingService } from "../../../services/loading.service";
import { ToasterService } from "../../../services/toaster.service";
import { FinanceApiService } from "../../../services/finance-a-p-iervice.service";
import { CustomerAgreementInterface } from "../../../models/customer-agreement.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { TosTableService } from "../../../services/tos-table.service";
import { CommonService } from "../../../services/common-service.service";
import userFilterConfig from "../../admin/user-management/config/userManagementFilterConfig.json";
import { DynamicFormComponent } from "../../dynamic-form/dynamic-form.component";
import { FileUploadComponent } from "../../file-upload/file-upload.component";
import CustomerAgreementFormConfig from "./config/CustomerAgreementFormConfig.json";
import { DynamicForm } from "../../../models/dynamic-form";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ModalComponent } from "../../modal/modal.component";
import { DynamicFormService } from "../../../services/dynamic-form.service";
import { FileSource, FileUploadService } from "../../../services/file-upload.service";
import { RequiresPermissionDirective } from "../../../directives/evaluate-permission.directive";
import { PermissionConstants } from "../../../constants/permission-constants";
import { CLICKABLE_TD_EVENT_KEY } from "../../tos-table/tos-table-td/tos-table-td.component";

const CUSTOMER_AGREEMENT_ACTIONS = {
  EDIT: "edit",
  VIEW: "view",
  CONFIGURE_CUSTOMER_AGREEMENT: "configure-customer-agreement",
  DOWNLOAD_ATTACHMENTS: "download-attachments",
  CLONE_AGREEMENT: "clone-agreement",
  ACTIVE: "active",
  INACTIVE: "inactive"
};

@Component({
  selector: "app-customer-agreement",
  standalone: true,
  imports: [
    SharedModule,
    SvgIconComponent,
    TosTableComponent,
    DynamicFormComponent,
    FileUploadComponent,
    RequiresPermissionDirective
  ],
  templateUrl: "./customer-agreement.component.html",
  styleUrl: "./customer-agreement.component.scss"
})
export class CustomerAgreementComponent {
  searchTerm: string = "";
  focusSearch: boolean = false;
  selectedItems: any[] = [];
  allTableRecordsSelected: boolean = false;
  tableMeta: TableMeta = CustomerAgreementListingTableConfig.listingTableConfig;
  searchBarConfig: SearchBarConfig = {
    filters: [
      {
        name: "CONTRACT_NO_CONTAINS",
        alias: "CONTRACT_NO_CONTAINS"
      }
    ],
    placeHolder: "Search By Contract Number"
  };
  menuOptions: TableMenuOption[] = [
    { label: "Edit", value: CUSTOMER_AGREEMENT_ACTIONS.EDIT, requiresPermission: {permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.EDIT]}},
    { label: "View", value: CUSTOMER_AGREEMENT_ACTIONS.VIEW, requiresPermission: {permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.VIEW]}},
    { label: "Configure Agreement", value: CUSTOMER_AGREEMENT_ACTIONS.CONFIGURE_CUSTOMER_AGREEMENT,requiresPermission: {permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.EDIT]}},
    {
      label: "Download Attachments",
      value: CUSTOMER_AGREEMENT_ACTIONS.DOWNLOAD_ATTACHMENTS,
      condition: (record) => record.fileUploads?.length > 0,
      requiresPermission: {permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.EDIT]}
    },
    { label: "Clone Agreement", value: CUSTOMER_AGREEMENT_ACTIONS.CLONE_AGREEMENT,requiresPermission: {permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.EDIT]}}
  ];
  rowsPerPage: number = 15;
  currentPage: number = 0;
  sortColumn: string = "modifiedDate";
  sortDirection: "asc" | "desc" = "desc";
  tableListRequest: TableListRequest = {
    limit: this.rowsPerPage,
    page: this.currentPage,
    orderBy: {
      [this.sortColumn]: this.sortDirection
    }
  };
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  customerAgreementFormConfig: DynamicForm = CustomerAgreementFormConfig;
  customerAgreementForm: FormGroup;
  selectedFiles: File[] = [];

  @ViewChild("customerAgreementCloneForm") customerAgreementCloneForm!: TemplateRef<any>;

  protected readonly userFilterConfig = userFilterConfig;
  protected readonly CustomerAgreementListingTableConfig = CustomerAgreementListingTableConfig;

  constructor(private financeApiService: FinanceApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private route: ActivatedRoute,
              private router: Router,
              private tosTableService: TosTableService,
              private commonService: CommonService,
              private viewContainerRef: ViewContainerRef,
              private fb: FormBuilder,
              private dynamicFormService: DynamicFormService,
              private fileUploadService: FileUploadService) {
    this.customerAgreementForm = this.fb.group({});
  }

  ngOnInit() {
    this.dynamicFormService.addControlsToForm(this.customerAgreementForm, this.customerAgreementFormConfig);
    this.getTableList();
  }


  addNewCustomerAgreement() {
    this.router.navigate(["add-new"], { relativeTo: this.route });
  }

  handleTableSearch(event: KeyboardEvent) {

  }

  bulkActionConfirmation(inActive: string) {

  }

  getTableList() {
    this.loadingService.show("inline");
    this.financeApiService.listCustomerAgreements(this.tableListRequest).subscribe({
      next: (res) => {
        this.tableListData = res.data;
        this.loadingService.hide();
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.errorDesc);
      }
    });
  }

  handleOptionSelected(event: any) {
    const { record, actionName } = event;
    const customerAgreementRecord: CustomerAgreementInterface = record;

    switch (actionName) {
      case "edit":
        this.router.navigate([`edit`, record.id], { relativeTo: this.route });
        break;
      case "view":
        this.router.navigate([`view`, record.id], { relativeTo: this.route });
        break;
      case "configure-customer-agreement":
        this.configureCustomerAgreement(record);
        break;
      case "download-attachments":
        this.commonService.downloadFilesAsZip(record.fileUploads.map((file: any) => file.id), record.contractNumber);
        break;
      case "clone-agreement":
        this.cloneAgreement(record);
        break;
      case "active":
        this.updateCustomerAgreementStatus(customerAgreementRecord, true);
        break;
      case "inactive":
        this.updateCustomerAgreementStatus(customerAgreementRecord, false);
        break;
      default:
        break;
    }

  }


  private updateCustomerAgreementStatus(customerAgreementRecord: CustomerAgreementInterface, b: boolean) {
  }

  private configureCustomerAgreement(event: any) {
    const customerAgreementId = event?.record?.id || event?.id;
    this.router.navigate([customerAgreementId, "configurations"], { relativeTo: this.route });
  }

  handleRowAction(event: any) {
    const action = event.actionName;
    switch (action) {
      case CLICKABLE_TD_EVENT_KEY:
        this.configureCustomerAgreement(event);
        break;
      case CUSTOMER_AGREEMENT_ACTIONS.DOWNLOAD_ATTACHMENTS:
        this.commonService.downloadFilesAsZip(event.record.fileUploads.map((file: any) => file.id), event.record.contractNumber);
        break;
      case CUSTOMER_AGREEMENT_ACTIONS.CLONE_AGREEMENT:
        this.cloneAgreement(event.record);
        break;
      default:
        console.warn("Invalid action", action);
        break;
    }
  }

  cloneAgreement(record: CustomerAgreementInterface) {
    const modalRef = this.viewContainerRef.createComponent(ModalComponent);
    modalRef.instance.title = "Clone Agreement";

    this.customerAgreementForm.patchValue({
      ...record,
      accountHolder: "",
      description: `${record.description} - copy`
    });
    this.selectedFiles = []

    const componentRef = modalRef.instance.loadComponent(this.customerAgreementCloneForm, {
      record
    });

    modalRef.instance.close.subscribe({
      next: () => {
        modalRef.destroy();
      }
    });
  }

  private callApiToCloneAgreement(record: CustomerAgreementInterface) {
    this.loadingService.show();
    this.financeApiService.cloneCustomerAgreement(record.id, record).subscribe({
      next: (res) => {
        this.getTableList();
        this.loadingService.hide();
        this.toasterService.success(`Agreement ${record.contractNumber} has been cloned successfully!`);
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.errorDesc);
      }
    }).add(() => {
      this.closeModal();
    });
  }

  async uploadFiles(): Promise<string[]> {
    const uploadedFileIds: string[] = [];
    const formDataArray = this.fileUploadService.createFormDataToSend(
      this.selectedFiles,
      FileSource.CUSTOMER_AGREEMENT
    );

    try {
      if (formDataArray.length > 0) {
        await this.fileUploadService.uploadFilesSequentially(formDataArray, uploadedFileIds);
      }
      return uploadedFileIds;
    } catch (error) {
      console.error("File upload failed:", error);
      throw error;
    }
  }

  async save(data: CustomerAgreementInterface) {
    this.customerAgreementForm.markAllAsTouched();
    if (this.customerAgreementForm.invalid) return;

    const record: CustomerAgreementInterface = {
      ...this.customerAgreementForm.value,
      id: data.id,
      accountHolder: this.customerAgreementForm.get("accountHolder")?.value?.key
    };
    const fileUploadIds = await this.uploadFiles();
    record.fileUploads = fileUploadIds.map((id) => {
      return {
        id
      };
    });
    this.callApiToCloneAgreement(record);
  }

  closeModal() {
    const modalComponent = this.viewContainerRef.get(0);
    if (modalComponent) {
      const modalRef = modalComponent as unknown as ComponentRef<ModalComponent>;
      if (modalRef.instance) {
        modalRef.instance.close.next();
      }
      modalRef.destroy();
    }
    this.viewContainerRef.clear();
  }

  protected readonly PermissionConstants = PermissionConstants;
}
